export default {
    title: "Potwierdzenie dostawy",
    header: "@:views.survey.delivery.title",
    result: {
        header: "Dziękuję",
        message: "Dziękuję za odpowiedź."
    },
    status: {
        yes: "Proszę sprawdzić zaznaczone poniżej produkty, aby potwierdzić dostawę i odznaczyć te, których nie otrzymałeś. Następnie kliknij „Wyślij”, aby potwierdzić.",
        no: "Sprawdź, czy nie otrzymałeś żadnego z poniższych produktów. Jeśli otrzymałeś któryś z tych produktów, zaznacz pole obok otrzymanych produktów i kliknij „Prześlij”, aby potwierdzić."
    },
    model: {
        checked: {
            label: "Otrzymane"
        }
    },
    button: {
        submit: {
            cta: "Składać",
            processing: "Przedkładający"
        }
    }
}